import React, { useState } from 'react'
import Download from './Download'
import Tabbar from '../Tabbar'
import Filter from '../Filter'
import { updateStateJurnal,setCurrentKategori, setKategoriId  } from '../../features/jurnalSlice'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

function TabbarAndFilter() {
  const { listTabbar } = useSelector(state => state.jurnal)
  let [searchParams] = useSearchParams();
  const [slicedParams, setSlicedParams] = useState([])

  useEffect(() => {
    const paramsObject = Object.fromEntries(new URLSearchParams(searchParams));
    paramsObject.paginate = 1;
    const updatedSearchParams = new URLSearchParams(paramsObject).toString();
    setSlicedParams(updatedSearchParams);
  }, [searchParams])

  return (
    <div className='tabbar-filter'>
      <Tabbar
        options={listTabbar}
        setKategoriId={setKategoriId}
        setCurrentKategori={setCurrentKategori}
        setKeterangan={updateStateJurnal}
        searchParams={slicedParams.toString()}
        path='/jurnalguru'
        loading={false}
      />
      <div className='filter-download'>
        <Filter option1="Mengajar" option2="Penugasan"
          setState={updateStateJurnal}
        />
        <Download />
      </div>
    </div>
  )
}

export default TabbarAndFilter